export default "__VITE_ASSET__beb619b9__"